module.exports = __webpack_public_path__ + "img/pl_dis.1c38a0f9.png";